/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-profile-alt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M11.875 8.125h4.375v1.25h-4.375v-1.25zm0-3.125h6.875v1.25h-6.875V5zm0-3.125h6.875v1.25h-6.875v-1.25zm-5 16.875h-2.5a1.254 1.254 0 01-1.25-1.25v-4.375a1.254 1.254 0 01-1.25-1.25v-3.75A1.841 1.841 0 013.75 6.25H7.5a1.841 1.841 0 011.875 1.875v3.75a1.254 1.254 0 01-1.25 1.25V17.5a1.254 1.254 0 01-1.25 1.25zM3.75 7.5a.59.59 0 00-.625.625v3.75h1.25V17.5h2.5v-5.625h1.25v-3.75A.59.59 0 007.5 7.5H3.75zm1.875-1.875a2.5 2.5 0 112.5-2.5 2.508 2.508 0 01-2.5 2.5zm0-3.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"/>'
  }
})
